import request from './request';
import Vue from 'vue';
import store from '../../store/store';
import {API, VUE_APP_CHANNEL_NAME} from '@/const';
import * as ACTION from '@/store/actionTypes';


const authApi = {
    get_channel_key() {
        let channel_host
        if (VUE_APP_CHANNEL_NAME){
            channel_host = VUE_APP_CHANNEL_NAME
        } else {
            channel_host = document.location.host.split('.')[0];
        }
        return request(channel_host + '.json', {}, 'get', API.API_KEYS_HOST)
            .then((res) => {
                store.cache.clear();
                return res
            })
    },
    get_api_key(params = {}) {
        if (Vue.$storage.get('api_key')) {
            return {
                data: {api_key: Vue.$storage.get('api_key')}
            }
        }
        Object.assign(params, {
            channel_key: Vue.$storage.get('channel_key')
        });
        return request('/get_api_key', params)
    },
    profile() {
        return request('/profile', {}, 'get');
    },
    login: function (params = {}) {
        return request('auth/login', params)
            .then((res) => {
                store.cache.clear();
                return res
            });
    },
    logout: function () {
        return request('auth/logout')
            .then(async () => {
                store.cache.clear();
                await resetAuthData();
            })
    },
    registration: function (params = {}) {
        return request('auth/register', params)
            .then((res) => {
                store.cache.clear();
                return res
            });
    },
    verify: function (params = {}) {
        return request('auth/email-verify', params);
    },
    passwordResetRequest: function (params = {}) {
        return request('auth/password-reset-request', params);
    },
    passwordReset: function (params = {}) {
        return request('auth/password-reset', params);
    },
    updateProfile: function (params = {}) {
        Object.assign(params, {_method: 'patch'});
        return request('profile', params);
    },
};

const resetAuthData = () => {
    Vue.$storage.set('api_key', null);
    return new Promise((resolve) => {
        store.dispatch(ACTION.GET_API_KEY).then(() => {
            resolve(); //После переавторизации обновим странцицу
        })
    })

};

export default authApi;
